import React, { useMemo } from 'react';
import { isNil as _isNil } from 'lodash';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import { Tooltip } from '@mui/material';
import { styled } from '@mui/material/styles';
//
import { isNotificationDateIsDue } from 'utils/common';

const WarningWrapper = styled('p')(() => ({
  fontWeight: 600,
  ['& + &']: {
    borderTop: '1px solid white',
    paddingTop: '0.75rem',
  },
}));
const validateAlert = (flag, date) => {
  // if flag or date is missing or flag is false
  if (_isNil(flag) || _isNil(date) || !flag) {
    return false;
  }
  return isNotificationDateIsDue(date);
};

const VALIDATORS = [
  {
    message: 'App Domain SSL is close to expire',
    check: ({ isSSLAppAlert, sslAppAlertDate }) =>
      validateAlert(isSSLAppAlert, sslAppAlertDate),
  },
  {
    message: 'App Domain is close to expire',
    check: ({ isDomainAppAlert, domainAppAlertDate }) =>
      validateAlert(isDomainAppAlert, domainAppAlertDate),
  },
  {
    message: 'Tracking Domain SSL is close to expire',
    check: ({ isSSLTrackAlert, sslTrackAlertDate }) =>
      validateAlert(isSSLTrackAlert, sslTrackAlertDate),
  },
  {
    message: 'Tracking Domain is close to expire',
    check: ({ isDomainTrackAlert, domainTrackAlertDate }) =>
      validateAlert(isDomainTrackAlert, domainTrackAlertDate),
  },
];

export function RenderWLIDWarningCell({ row }) {
  const warnings = useMemo(
    () =>
      VALIDATORS.filter(({ check }) => check(row)).map(
        ({ message }) => message,
      ),
    [row],
  );
  const warningsSorted = useMemo(
    () =>
      warnings.map((text, idx) => (
        <WarningWrapper key={idx}>{text}</WarningWrapper>
      )),
    [warnings],
  );
  if (warnings.length === 0) {
    return <CheckCircleIcon sx={{ verticalAlign: 'middle' }} color='success' />;
  }
  return (
    <Tooltip arrow title={warningsSorted}>
      <ErrorIcon sx={{ verticalAlign: 'middle' }} color='error' />
    </Tooltip>
  );
}
